import cn from 'classnames'
import React, { useEffect, useState } from 'react'

import { bindListeners, wistiaServiceUrl } from '../../utils/attach-wistia-lazy'
import { useScript } from '../hooks'

const WistiaPopover = ({ videoId = '', children }) => {
  const [videoSrc, setVideoSrc] = useState('')
  const wistiaLoadHandler = () => setVideoSrc(wistiaServiceUrl)
  useScript(videoSrc)

  useEffect(() => {
    bindListeners(videoId, wistiaLoadHandler)
    return () => {
      bindListeners(videoId, wistiaLoadHandler, true)
    }
  }, [videoId])

  return (
    <span
      className={cn(
        'c-media__video wistia_embed popover=true popoverContent=html',
        `wistia_async_${videoId}`
      )}
    >
      {children}
    </span>
  )
}

export default WistiaPopover
